import { AxiosResponse } from "axios";
import { ChangeEvent, useEffect, useState } from "react";
import { fetch, post } from "src/common/networks/api-helper";
import { URL_PATHS } from "src/common/networks/url-paths";
import { BankAccount } from "src/libraries/types/bank";
import ToastifyAdapter from "src/libraries/components/toastify/toastify.adapter";

export const BankAdapter = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const { errorFromAPI, success } = ToastifyAdapter();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isOpenDetailBankScreen, setIsOpenDetailBankScreen] =
    useState<boolean>(false);
  const [bankData, setBankData] = useState<BankAccount[]>([]);
  const [isStepOneCompleted, setIsStepOnecompleted] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalItem, setTotalItem] = useState<number>(0);
  const pageSize = 4;
  useEffect(() => {
    getListBank();
  }, []);
  const displayData = bankData.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );
  const onPageChange = (page: number) => {
    console.log(page);

    setCurrentPage(page);
  };

  const getListBank = () => {
    setLoading(true);
    fetch(URL_PATHS.GET_LIST_BANK, null, false)
      .then((res) => {
        console.log(res);

        if (res) {
          setBankData(res.data);
          setTotalItem(res.data.length);
          setLoading(false);
        }
      })
      .catch((e) => {
        errorFromAPI(e.response.data.code, e.response.data.message);
        console.log("ERROR GET LIST BANK", e);
      });
  };

  const createNewBank = (data: Record<string, any>) => {
    setLoading(true);
    post(URL_PATHS.CREATE_NEW_BANK, data, true)
      .then((res) => {
        console.log(res);
        if (res) {
          success("Tạo tài khoản thành công");
          setLoading(false);
          getListBank();
        }
      })
      .catch((e) => {
        errorFromAPI(e.response.data.code, e.response.data.message);
        console.log("ERROR CREATE NEW BANK", e);
      });
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
  };

  const showModal = () => {
    setIsModalVisible(true);
  };
  const handleOk = (data: Record<string, any>) => {
    console.log(data);
    createNewBank(data);
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return {
    loading,
    totalItem,
    currentPage,
    onPageChange,
    isModalVisible,
    isStepOneCompleted,
    showModal,
    handleOk,
    handleCancel,
    handleChange,
    displayData,
    isOpenDetailBankScreen,
    setIsOpenDetailBankScreen,
  };
};
